import * as React from 'react';
import * as _ from 'lodash';
import { Config } from '../../../helper';

export function buildExtraFields(source, mapping) {
  const pathsConfig = mapping[Config.Mapping.Accordion.ExtraFields];
  if (!pathsConfig) return [];

  // Labels are matched to paths by line index, so keep both lists aligned to the original
  // lines: don't filter blank path lines out (that would shift every subsequent label up by
  // one) — skip them in place instead.
  const paths = pathsConfig.split('\n').map(s => s.trim());
  const labelsConfig = mapping[Config.Mapping.Accordion.ExtraFieldLabels];
  const labels = labelsConfig ? labelsConfig.split('\n').map(s => s.trim()) : [];

  const rows = [];
  paths.forEach((path, idx) => {
    if (!path) return;
    const value = _.get(source, path);
    if (value === undefined || value === null) return;
    rows.push({
      label: labels[idx] || path,
      items: Array.isArray(value) ? value : [value],
    });
  });

  return rows;
}

export default function DescriptionList({list}) {
  if (!Array.isArray(list) || !list.length) return null;

  return (
    <div className='accordion-item__description-list'>
      {list.map((row, idx) => (
        <div key={idx} className='accordion-item__description-list-row'>
          <div className='accordion-item__description-list-row-label'>{row.label}:</div>
          <div className='accordion-item__description-list-row-content'>
            <p className='mb-0'>{Array.isArray(row.items) ? row.items.join(', ') : row.items}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
